import { IconDashboard, IconFile, IconNotification, IconUser } from './icons';
import { mobileTabs, type MobileTabPath } from '../app/navigation';

const icons = {
  workbench: IconDashboard,
  tasks: IconFile,
  notices: IconNotification,
  me: IconUser
};

type MobileBottomNavProps = {
  activePath: MobileTabPath | null;
  onNavigate: (path: MobileTabPath) => void;
};

function MobileBottomNav({ activePath, onNavigate }: MobileBottomNavProps) {
  return (
    <nav className="mobile-prototype__bottom-nav" aria-label="移动端主导航">
      {mobileTabs.map(({ path, label, icon, disabled }) => {
        const Icon = icons[icon];
        return (
          <button
            key={path}
            type="button"
            className={`mobile-prototype__tab${activePath === path ? ' mobile-prototype__tab--active' : ''}`}
            aria-current={activePath === path ? 'page' : undefined}
            disabled={disabled}
            title={disabled ? `${label}暂未开放` : undefined}
            onClick={() => onNavigate(path)}
          >
            <Icon aria-hidden="true" />
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default MobileBottomNav;
